import { setPath as ramdaSetPath } from 'remeda';

/**
 * Remeda's `setPath()` is cautious about union types, especially when
 * they are nested. For example, it does not want us to set `isFreeForm`
 * on a `ForkedAnswer`. This function allows us to manually provide a type
 * when we have already narrowed the type elsewhere.
 */
export const setPath = <T = Record<string, unknown>>(
    obj: T,
    path: string[],
    value: unknown
): T =>
    // @ts-expect-error allow any path
    ramdaSetPath(obj, path, value);
